const testimonials = [
  {
    name: "Jennifer L.",
    location: "Marietta, GA",
    rating: 5,
    text: "We planned a family cruise out of Miami and realized my son's passport was expired two weeks before sailing. Fast Passport Center had his expedited passport processed in 5 days. Their team was amazing every step of the way.",
    service: "Child Passport",
  },
  {
    name: "David P.",
    location: "Smyrna, GA",
    rating: 5,
    text: "Business trip to Tokyo moved up unexpectedly. I'm in Marietta and couldn't afford to drive downtown Atlanta for a passport agency appointment. Started online, shipped from the UPS Store on Cobb Parkway, and had my emergency passport in 3 business days.",
    service: "Emergency Passport",
  },
  {
    name: "Michelle R.",
    location: "Kennesaw, GA",
    rating: 5,
    text: "After my divorce, I needed a name change on my passport before our honeymoon. Fast Passport Center handled everything through the expedited process. They even caught a mistake on my marriage certificate copy before submission.",
    service: "Name Change",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MariettaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Cobb County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Marietta, Smyrna, Kennesaw, and Cobb County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}